import { useMutation } from 'react-query';
import quoterApiInstance from '../../api/quoterApiInstance';
import { MUTATION_KEYS } from '../../constants/reactQuery';

/**
 * POST /my-favorite-plans
 *
 * @param {object} payload  Plan a guardar: `description` (el nombre que escribe el
 *   usuario) y `data` (el request de `/rate-engine/compute`), p. ej.:
 *   {
 *     description: 'Gold Plan - Family',
 *     data: {
 *       initialCoverageDate: '2026-07-20',     // request de pricing, re-enviable tal cual
 *       maxCoverage: 'maxcovpipoly_2000000',
 *       benefits: [...], riders: [...], beneficiaries: [...],
 *       contextData: { ... },                  // estado del formulario, para rehidratar
 *     },
 *   }
 * @returns {Promise<object>} Body completo: { data: {...plan}, message, status }
 */
const saveFavoritePlan = async (payload) => {
    const { data } = await quoterApiInstance.post('/my-favorite-plans', payload);
    // Se devuelve el body entero para que el consumidor pueda leer tanto el plan
    // creado (`data`) como `message` / `status`.
    return data;
};

/**
 * Crea (guarda) un plan favorito.
 *
 * No invalida la cache del dashboard: tras guardar se navega a `/dashboard`, que al
 * montar refetchea lista y métricas por `DASHBOARD_QUERY_CONFIG` (staleTime 0 +
 * refetchOnMount 'always'). Acepta las mismas `options` que `useMutation`
 * (`onError` se encadena después de la interna; `onSuccess` pasa tal cual vía `...options`).
 */
export const useSaveFavoritePlan = (options = {}) => {
    return useMutation(
        MUTATION_KEYS.favoritePlans.create,
        (payload) => saveFavoritePlan(payload),
        {
            ...options,
            onError: (error, variables, context) => {
                console.error('Error saving favorite plan:', error);
                options.onError?.(error, variables, context);
            },
        }
    );
};

export default useSaveFavoritePlan;
